import React from 'react';
import { Button } from 'semantic-ui-react';

const SlackButton = props => (
  <Button
    basic={props.basic || false}
    color="violet"
    icon="slack"
    onClick={props.onSignIn}
    content={props.content || 'Sign in with Slack'}
  />
);

export default SlackButton;



// WEBPACK FOOTER //
// ./src/components/SlackButton.js